import { Modal } from "@visiblethread/react-components";
import Flex, { GAP_CLASS } from "components/Flex";
import { DOC_SOURCE } from "constants/documents";
import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDocumentStyleTemplates } from "slices/settings/actions/addInSettings";
import { selectHasStyleTemplates } from "slices/settings/selectors/addInSettingsSelectors";

import StartWritingProposalOutlineContext from "../context";
import { STEPS_KEYS } from "../StartWritingProposalOutlineWizard";
import AddInSourceCard from "./AddInSourceCard";
import common from "./common.module.scss";
import { GENERATE_BTN, NEXT_BTN } from "./constants";
import ModalFooter from "./ModalFooter";
import VtSourceCard from "./VtSourceCard";
import WizardProgressBar from "./WizardProgressBar";

const DocumentSource = () => {
  const { hasConflicts, onConfirmStart, setSource, setStep, source } =
    useContext(StartWritingProposalOutlineContext);
  const dispatch = useDispatch();
  const hasStyleTemplates = useSelector(selectHasStyleTemplates);
  const enableTemplateSelection =
    source === DOC_SOURCE.ADDIN && hasStyleTemplates;

  useEffect(() => {
    dispatch(fetchDocumentStyleTemplates());
  }, []);

  let nextButtonText = hasConflicts ? NEXT_BTN : GENERATE_BTN;
  if (enableTemplateSelection) {
    nextButtonText = NEXT_BTN;
  }

  const onClickNext = () => {
    if (enableTemplateSelection) {
      setStep(STEPS_KEYS.TEMPLATES);
      return;
    }

    if (!hasConflicts) {
      onConfirmStart(source);
      return;
    }

    setStep(STEPS_KEYS.CONFLICTS);
  };

  return (
    <>
      <Modal.Body className={common.body}>
        <p>Choose where you want to write.</p>

        <WizardProgressBar value={20} />

        <Flex alignItems="stretch" gap={GAP_CLASS.GAP_300}>
          <VtSourceCard
            isActive={source === DOC_SOURCE.VT_EDITOR}
            onClick={setSource}
          />

          <AddInSourceCard
            isActive={source === DOC_SOURCE.ADDIN}
            onClick={setSource}
          />
        </Flex>
      </Modal.Body>

      <ModalFooter
        isNextDisabled={source === undefined}
        nextButtonText={nextButtonText}
        onClickNext={onClickNext}
        stepNumber={1}
      />
    </>
  );
};

export default DocumentSource;
